module.exports = __webpack_public_path__ + "static/q10_x-b7c1485ada3795451477ffa94f3bc129.png";